





























































































































































































































import { Component, Vue } from 'vue-property-decorator';
import difference from 'lodash/difference'
import capitalize from 'lodash/capitalize'
import _get from 'lodash/get'
import moment from 'moment'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
])

const errorMap = [
  'Import success',
  'Face rejected',
  'Error in personnel information data',
  'Could not detect face',
  'Face feature value extraction failed',
  'Multiple faces detected',
  'The image size does not meet the requirements',
  'Picture decoding failed',
  'Picture copy failed',
  'No pictures',
  'Failed to write personnel information to database',
  'The picture quality is too low.',
  'Facial similarity is too high',
  'One registration limit is exceeded',
  'The picture format does not meet the requirements',
  'Application internal error',
  'Duplicate registration error',
  'Facial is considered to be someone else',
  'Face registration verification successful',
  'Face registration validation failed',
  'Json data parsing error',
]

@Component
export default class Device extends Vue {
  loading: boolean = false
  modalVisible: boolean = false
  modalLoading: boolean = false
  modalTitle: string = 'Add Device'
  employeeLoading: boolean = false
  employeeModal: boolean = false
  employeeModalTitle: string = ''
  employeeUpdateModal: boolean = false
  employeeUpdateModalTitle: string = ''
  employeeUpdateLoading: boolean = false
  serverModalVisible: boolean = false
  serverModalLoading: boolean = false
  serverForm = {} as any
  serverModalTitle: string = ''
  serverRules = {
    serverPath: [
      { required: true, message: 'Server path must not be empty', trigger: 'blur' },
    ]
  }
  interval = 20
  columns = [
    {
      title: 'Name',
      dataIndex: 'name'
    },
    {
      title: 'Device Key',
      dataIndex: 'deviceKey'
    },
    {
      title: 'Server Path',
      dataIndex: 'serverPath'
    },
    {
      title: 'Status',
      dataIndex: 'lastActive',
      scopedSlots: { customRender: 'status' },
    },
    {
      title: 'Action',
      dataIndex: 'operation',
      fixed: 'right',
      width: 320,
      scopedSlots: { customRender: 'action' },
    },
  ]
  employeeColumns = [
    {
      title: 'Id',
      dataIndex: 'id'
    },
    {
      title: 'Name',
      dataIndex: 'name'
    },
    {
      title: 'Uploaded',
      dataIndex: 'uploaded',
      align: 'center',
      scopedSlots: { customRender: 'status' },
    },
    {
      title: 'Verified',
      dataIndex: 'verified',
      align: 'center',
      scopedSlots: { customRender: 'verification' },
    },
    {
      title: 'Error Code',
      dataIndex: 'uploadError',
      scopedSlots: { customRender: 'error' },
    }
  ]
  sourceColumns = [
    {
      dataIndex: 'title',
      title: 'Id',
    },
    {
      dataIndex: 'description',
      title: 'Name',
    },
  ]
  form = {}
  isEdit: boolean = false
  timer:any 
  isMounted: boolean = false
  errorMap = errorMap
  rules = {
    deviceKey: [
      { required: true, message: 'Device Id must not be empty', trigger: 'blur' },
    ],
    name: [
      { required: true, message: 'Name must not be empty', trigger: 'blur' },
    ],
    org: [
      { required: true, message: 'Organization must not be empty', trigger: 'blur' },
    ]
  }

  get role() {
    return this.$store.state.userStore.role
  }

  get devices() {
    return this.$store.state.deviceStore.devices 
  }

  get total() {
    return this.$store.state.deviceStore.total
  }

  get pagination() {
    return this.$store.state.deviceStore.pagination
  }

  get employeePagination() {
    return this.$store.state.deviceStore.employeePagination
  }

  get employees() {
    return this.$store.state.deviceStore.employees
  }

  get employeeList() {
    return this.$store.state.employeeStore.employeeList
  }

  get targetEmployees() {
    return this.$store.state.deviceStore.targetEmployee
  }

  get searchKey() {
    return this.$store.state.deviceStore.search
  }

  set searchKey(val) {
    this.$store.commit('updateDeviceSearchKey', val)
  }

  get organizationList() {
    return this.$store.state.organizationStore.organizationList
  }

  get organization() {
    return this.$store.state.deviceStore.organization
  }

  set organization(val) {
    this.$store.commit('updateCurrentDeviceOrg', val)
  }

  mounted() {
    this.isMounted = true
    this.loadDevice()
    this.timer = setInterval(() => {
      this.loadDevice()
    }, this.interval * 1000)
  }
  
  beforeRouteEnter(to: any, from: any, next: any) {
    if (this && this.isMounted) {
      this.timer = setInterval(() => {
        this.loadDevice()
      }, this.interval * 1000)
    }
    next()
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    clearInterval(this.timer)
    next()
  }

  loadDevice() {
    this.loading = true
    this.$store.dispatch('getDevices', {
      page: this.pagination.current,
      limit: this.pagination.pageSize
    }).then(() => {
      this.loading = false
    })
    .catch(() => {
      this.loading = false
    })
  }

  updateDevices(pagination:any, filters:any, sorter:any) {
    this.loading = true
    this.$store.commit('updateDevicePagination', {current: pagination.current})
    this.$store.commit('updateDeviceSorter', {field: sorter.field, order: sorter.order === 'ascend'? 'asc': 'desc'})
    this.$store.dispatch('getDevices').then(() => {
      this.loading = false
    })
  }

  search() {
    this.loading = true
    this.$store.commit('updateDevicePagination', {current: 1})
    this.$store.dispatch('getDevices').then(() => {
      this.loading = false
    })
  }

  showCreateDevice() {
    this.modalVisible = true
    this.modalTitle = 'Create Device'
    this.isEdit = false
    this.form = {
      serverPath: window.location.origin + process.env.BASE_URL,
      volume: 84,
      live: 0,
      multi: 1,
      polling: 30,
      timeout: 0,
      lightStatus: 1,
      autoLightStatus: 1,
      faceThreshold: 0.45,
      maxTemp: 37.3,
      minTemp: 28.5,
      tempScreening: 1,
      nonEmp: 0,
      mask: 1,
      tempComp: 850
    }
  }

  showEditDevice(device: any) {
    this.form = { ...device }
    this.modalTitle = 'Edit Device'
    this.isEdit = true
    this.modalVisible = true
  }

  showDeletion(device: any) {
    const h = this.$createElement
    const _this = this
    this.$confirm({
      title: 'Device Delete',
      okText: 'Confirm',
      content: h('div', {}, [
        'Are you sure you want to delete ',
        h('strong', device.name),
        '?'
      ]),
      onOk() {
        _this.$store.dispatch('deleteDevice', device.id)
      }
    })
  }

  showEmployee(device: any) {
    this.employeeModal = true
    this.employeeModalTitle = 'Employees for ' + device.name
    this.employeeLoading = true
    this.$store.commit('updateDeviceEmployeePagination', {current: 1})
    this.$store.commit('updateCurrentDevice', device.id)
    this.$store.dispatch('getDeviceEmployee').then(() => {
      this.employeeLoading = false
    })
  } 

  updateEmployee(pagination:any) {
    this.employeeLoading = true
    this.$store.commit('updateDeviceEmployeePagination', {current: pagination.current})
    this.$store.dispatch('getDeviceEmployee').then(() => {
      this.employeeLoading = false
    })
  }

  editEmployee(device: any) {
    this.employeeUpdateModal = true
    this.employeeUpdateModalTitle = 'Edit Employee for ' + device.name
    this.$store.commit('updateCurrentDevice', device.id)
    if (this.role === 'admin') {
      this.$store.dispatch('listEmployee', device.org)
    }
    else {
      this.$store.dispatch('listEmployee')
    }
    this.$store.dispatch('getDeviceEmployee', true)
  }

  onListUpdate(nextTarget: any) {
    this.$store.commit('updateTargetEmployee', nextTarget)
  }

  getRowSelection({ disabled, selectedKeys, itemSelectAll, itemSelect }: any) {
    return {
      getCheckboxProps: (item:any) => ({ props: { disabled: disabled || item.disabled } }),
      onSelectAll(selected: any, selectedRows: any) {
        const treeSelectedKeys = selectedRows
          .filter((item: any) => !item.disabled)
          .map(({ key }: any) => key);
        const diffKeys = selected
          ? difference(treeSelectedKeys, selectedKeys)
          : difference(selectedKeys, treeSelectedKeys);
        itemSelectAll(diffKeys, selected);
      },
      onSelect({ key }: any, selected: any) {
        itemSelect(key, selected);
      },
      selectedRowKeys: selectedKeys,
    }
  }

  saveDevice() {
    this.modalLoading = true
    if (this.isEdit) {
      return this.$store.dispatch('updateDevice', this.form).then(() => {
        this.modalLoading = false
        this.modalVisible = false
        this.form = {}
        this.$message.success("Device Updated")
      })
      .catch(e => {
        this.modalLoading = false
        this.$message.error(JSON.stringify(_get(e, 'response.data.messages', 'Something went wrong')))
      })
    }
    else {
      return this.$store.dispatch('addDevice', this.form).then(() => {
        this.modalLoading = false
        this.modalVisible = false
        this.form = {}
        this.$message.success("Device Created")
      })
      .catch(e => {
        this.modalLoading = false
        this.$message.error(_get(e, 'response.data.messages.deviceKey', _get(e, 'response.data.messages', 'Something went wrong')))
      })
    }
  }
  
  saveEmployeeList() {
    this.employeeUpdateLoading = true
    this.$store.dispatch('updateDeviceEmployee').then(() => {
      this.employeeUpdateLoading = false
      this.employeeUpdateModal = false
    })
  }

  cancelForm() {
    this.modalVisible = false
    this.modalLoading = false
    this.form = {}
  }

  cancelEmployeeList() {
    this.employeeUpdateModal = false
    this.employeeUpdateLoading = false
  }

  showAction(action: string, device: any) {
    const _this = this
    const h = this.$createElement
    const content = [
      `Are you sure you want to ${action} `,
      h('strong', device.name),
      '?'
    ]
    if (action === 'reset') {
      content.push(h('br'))
      content.push('Caution! This will reset device to default settings!')
    }
    this.$confirm({
      title: 'Device ' + capitalize(action),
      okText: 'Confirm',
      content,
      onOk() {
        _this.$store.dispatch('updateAction', {'id': device.id, 'action': action})
      }
    })
  }

  getStatus(record: any) {
    return moment(record.lastActive).add(record.interval >= 10? record.interval: 10, 'second').isAfter(moment())
  }

  showEditServerPath(device: any) {
    this.serverForm = { serverPath: device.serverPath }
    this.serverModalTitle = `Edit Device (${device.name}) Server Path`
    this.serverModalVisible = true
    this.$store.commit('updateCurrentDevice', device.id)
  }

  saveServerPath() {
    this.serverModalLoading = true
    this.$store.dispatch('updateServerPath', this.serverForm.serverPath).then(() => {
      this.serverModalLoading = false
      this.serverModalVisible = false
      this.serverForm = {}
      this.$store.dispatch('getDevices')
    })
    .catch(() => {
      this.$message.error('Failed to save server path')
      this.serverModalLoading = false
    })
  }

  cancelServerForm() {
    this.serverModalVisible = false
    this.serverModalLoading = false
    this.serverForm = {}
  }

}
